export default "__VITE_ASSET__CBhwLCi2__"